import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DatiqInputErrorTypes } from '@dat/datiq-components-pkg/utils';
import {
    isControlValueARange,
    isDateInvalidRange,
} from './datiq-datepicker-validator-utils';

export const range: ValidatorFn = (
    control: AbstractControl
): ValidationErrors | null => {
    const invalid: boolean = isControlValueARange(control)
        ? isDateInvalidRange(control?.value)
        : false;
    return invalid ? { [DatiqInputErrorTypes.DateRange]: true } : null;
};
